import { useEffect, useRef } from 'react'
import { type WizardAccount } from '../domain/types'

interface FlowEntryOptions {
  seededAccounts: WizardAccount[] | null
  deepLinkOpeningId: string | null
  deepLinkIsView: boolean
  startNew: (accounts: WizardAccount[]) => void
  resume: (openingId: string, asReadOnly: boolean) => void
}

export const useFlowEntry = ({ seededAccounts, deepLinkOpeningId, deepLinkIsView, startNew, resume }: FlowEntryOptions): void => {
  const handled = useRef(false)

  useEffect(() => {
    if (handled.current) {
      return
    }
    if (seededAccounts && seededAccounts.length > 0) {
      handled.current = true
      startNew(seededAccounts)
      return
    }
    if (deepLinkOpeningId) {
      handled.current = true
      resume(deepLinkOpeningId, deepLinkIsView)
    }
  }, [seededAccounts, deepLinkOpeningId, deepLinkIsView, startNew, resume])
}
